import React, { useEffect, useState } from "react";
import axios from "axios";
import { PieChart } from "@mui/x-charts/PieChart";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

export default function GradientPie({ userId }) {
  const [filledSlotsData, setFilledSlotsData] = useState({
    bullish: 0,
    bearish: 0,
    // nifty: 0, // optional if you need
    bankNifty: 0,
  });
  const [loading, setLoading] = useState(true);

  const gradients = [
    { id: "grad1", colors: ["#B2F2BB", "#8EE4AF"] },
    { id: "grad2", colors: ["#FFB3B3", "#FF6F61"] },
    // { id: "grad3", colors: ["#A8C6FF", "#5E9BFF"] },
    { id: "grad4", colors: ["#FFD8A8", "#FFAD60"] },
  ];

  const getFilledSlots = async () => {
  setLoading(true);
  try {
    const res = await axios.get("https://prod-erp.nifty10.in/get/filledSlots", {
      params: { userId }, // optional if your backend needs it
    });
    const data = res.data.data || {};
    setFilledSlotsData(data);
  } catch (err) {
    console.error("Error fetching filled slots:", err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    getFilledSlots();
  }, []);

  const data = [
    { id: 0, value: filledSlotsData.bullish, label: "BULLISH", color: "url(#grad1)" },
    { id: 1, value: filledSlotsData.bearish, label: "BEARISH", color: "url(#grad2)" },
    // { id: 2, value: filledSlotsData.nifty, label: "NIFTY PREDICTION", color: "url(#grad3)" },
    { id: 2, value: filledSlotsData.bankNifty, label: "BANK NIFTY", color: "url(#grad4)" },
  ];

  const total = data.reduce((sum, d) => sum + d.value, 0);

  if (loading) return <p>Loading bid stats...</p>;

  // 🎨 Tooltip styled like your image
  const tooltipContent = (
    <Box sx={{ textAlign: "left", lineHeight: 1.6, fontSize: "0.9rem" }}>
      <strong style={{ display: "block", marginBottom: 4 }}>Filled Slots:</strong>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span
          style={{
            width: 10,
            height: 10,
            backgroundColor: "#8EE4AF",
            borderRadius: "50%",
          }}
        />
        <span>Bullish: {filledSlotsData.bullish}</span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span
          style={{
            width: 10,
            height: 10,
            backgroundColor: "#FF6F61",
            borderRadius: "50%",
          }}
        />
        <span>Bearish: {filledSlotsData.bearish}</span>
      </div>

      {/* <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span
          style={{
            width: 10,
            height: 10,
            backgroundColor: "#5E9BFF",
            borderRadius: "50%",
          }}
        />
        <span>Nifty Prediction: {filledSlotsData.nifty}</span>
      </div> */}

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span
          style={{
            width: 10,
            height: 10,
            backgroundColor: "#FFAD60",
            borderRadius: "50%",
          }}
        />
        <span>Bank Nifty Prediction: {filledSlotsData.bankNifty}</span>
      </div>
    </Box>
  );

  return (
    <div className="todo-container">
      <div className="pie-title">
        <h3>Bid Stats</h3>
      </div>

      <Tooltip title={tooltipContent} placement="top" arrow>
        <div>
          <PieChart
            series={[
              {
                data,
                highlightScope: { faded: "global", highlighted: "item" },
                valueFormatter: (item) => {
                  const percent =
                    total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
                  return `${item.label}: ${percent}% (${item.value})`;
                },
              },
            ]}
            width={300}
            height={300}
          >
            <defs>
              {gradients.map((g) => (
                <linearGradient
                  key={g.id}
                  id={g.id}
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor={g.colors[0]} />
                  <stop offset="100%" stopColor={g.colors[1]} />
                </linearGradient>
              ))}
            </defs>
          </PieChart>
        </div>
      </Tooltip>
    </div>
  );
}
